<template>
  <div class="create_wrapper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("edit") }}</h4>
      </div>

      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateCreateForm">
        <div class="container">
          <div class="row justify-content-between">
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  @keypress="isArabic"
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.ar.question"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.question_ar") }}
                </label>
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  @keypress="isEnglish"
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.en.question"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.question_en") }}
                </label>
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label for="textarea_1" class="form-label">
                  {{ $t("forms.labels.answer_ar") }}
                </label>
                <textarea
                  @keypress="isArabic"
                  class="form-control"
                  rows="5"
                  v-model="data.ar.answer"
                ></textarea>
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label for="textarea_1" class="form-label">
                  {{ $t("forms.labels.answer_en") }}
                </label>
                <textarea
                  @keypress="isEnglish"
                  class="form-control"
                  rows="5"
                  v-model="data.en.answer"
                ></textarea>
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label class="form-label"> النوع </label>
                <multiselect
                  v-model="data.user_type"
                  :options="userTypes"
                  label="name"
                  track-by="id"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="false"
                  :show-labels="false"
                ></multiselect>
              </div>
            </div>

            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  class="form-control"
                  v-model.trim="data.sort_order"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.sort_order") }}
                </label>
              </div>
            </div>

            <div class="col-lg-12 py-0">
              <v-checkbox
                :label="$t('forms.labels.is_active')"
                v-model="data.is_active"
                color="indigo lighten-2"
              ></v-checkbox>
            </div>
          </div>
        </div>

        <div class="buttons_wrapper">
          <button class="button_style_1">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Create",
  props: ["id"],
  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.faq.title"),
          disabled: false,
          href: "/faq/show-all",
        },
        {
          text: this.$t("breadcrumb.faq.edit"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,

      // ========== create_data
      data: {
        ar: {
          question: null,
          answer: null,
        },
        en: {
          question: null,
          answer: null,
        },
        user_type: null,
        sort_order: null,
        is_active: false,
      },
      userTypes: [
        { name: "عميل", id: "client" },
        { name: "متجر", id: "restaurant" },
        { name: "سائق", id: "driver" },
      ],
    };
  },

  methods: {
    getData() {
      this.$axios.get(`faq/${this.id}`).then((res) => {
        this.data.ar.question = res.data.data.ar.question;
        this.data.ar.answer = res.data.data.ar.answer;
        this.data.en.question = res.data.data.en.question;
        this.data.en.answer = res.data.data.en.answer;
        this.data.user_type = this.userTypes.find(
          (el) => el.id == res.data.data.user_type
        );
        this.data.sort_order = res.data.data.sort_order;
        this.data.is_active = res.data.data.is_active;
      });
    },
    // Validate Data
    validateCreateForm() {
      this.btnIsLoading = true;
      if (!this.data.ar.question || !this.data.en.question) {
        this.$iziToast.error({
          timeout: 5000,
          message: this.$t("forms.validation.question"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
      } else if (!this.data.ar.answer || !this.data.en.answer) {
        this.$iziToast.error({
          timeout: 5000,
          message: this.$t("forms.validation.answer"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
      } else if (!this.data.user_type) {
        this.$iziToast.error({
          timeout: 5000,
          message: "النوع مطلوب",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
      } else {
        this.submitData();
        return;
      }
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();
      submit_data.append("ar[question]", this.data.ar.question);
      submit_data.append("en[question]", this.data.en.question);
      submit_data.append("ar[answer]", this.data.ar.answer);
      submit_data.append("en[answer]", this.data.en.answer);
      submit_data.append("user_type", this.data.user_type.id);
      if (this.data.sort_order) {
        submit_data.append("sort_order", this.data.sort_order);
      }
      submit_data.append("is_active", +this.data.is_active);
      submit_data.append("_method", "PUT");

      this.$axios({
        method: "POST",
        url: `faq/${this.id}`,
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 5000,
            message: this.$t("editSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/faq/show-all" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 5000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },

    // getCategories() {
    //   this.$axios({
    //     method: "GET",
    //     url: `category/all`,
    //   }).then((res) => {
    //     this.categories = res.data.data.map((item) => {
    //       return {
    //         id: item.id,
    //         name: item.name,
    //       };
    //     });
    //   });
    // },
  },

  mounted() {
    // this.getMeals();
    this.getData();
    // this.getCategories();
  },
};
</script>
